import { WhatWeOfferTypes } from '../WhatWeOfferTypes';

export const isDescriptionAvailable = (
  inAmenitiesArray: WhatWeOfferTypes.TOtherBenefitsDetails[]
) => {
  return inAmenitiesArray.some(
    amenity =>
      amenity.oneLineDescriptionDetails &&
      amenity.oneLineDescriptionDetails.show === true
  );
};

export const isDefaultEvenVariant = (
  inAmenitiesArray: WhatWeOfferTypes.TOtherBenefitsDetails[]
) => {
  const descriptionAvailability = isDescriptionAvailable(inAmenitiesArray);
  const isInsideAcceptableRange =
    inAmenitiesArray.length % 2 === 0 && inAmenitiesArray.length <= 6;
  return descriptionAvailability && isInsideAcceptableRange;
};

export const isLongAmenitiesList = (
  inAmenitiesArray: WhatWeOfferTypes.TOtherBenefitsDetails[]
) => {
  if (inAmenitiesArray.length > 5) {
    return true;
  }
  return false;
};

export const getAmenitiesVariant = (inAmenitiesArray: any) => {
  return inAmenitiesArray.every(
    (oneLineDescriptionDetails: WhatWeOfferTypes.TOneLineDescription) =>
      oneLineDescriptionDetails &&
      oneLineDescriptionDetails.show === true &&
      oneLineDescriptionDetails.oneLineDescription.length > 0
  );
};
